<template>
  <div class="container">
    <van-nav-bar title="缴费详情" left-text="" left-arrow @click-left="onClickLeft"></van-nav-bar>
    <div class="menu">
      <van-field readonly label="抄表项目：" :value="communityName" />
      <van-field readonly label="抄表时间：" :value="time" />
      <van-field readonly label="缴费时间：" :value="payTime" />
    </div>
    <div class="mg12">
      <van-field center readonly label="抄表读数：" placeholder="" />
    </div>
    <div class="listbox">
      <van-row>
        <van-col span="6">电表编号</van-col>
        <van-col span="6">上期读数</van-col>
        <van-col span="6">本期读数</van-col>
        <van-col span="6">本期电量</van-col>
      </van-row>
      <van-row :key="index" v-for="(item,index) in meterList">
        <van-col span="6">{{item.meterNum}}</van-col>
        <van-col span="6">{{item.startValue}}</van-col>
        <van-col span="6">{{item.endValue}}</van-col>
        <van-col span="6">{{item.totalDegree}}</van-col>
      </van-row>
      <van-row>
        <van-col span="6">统计</van-col>
        <van-col span="6"></van-col>
        <van-col span="6"></van-col>
        <van-col span="6">{{totalDegree.toFixed(2)}}</van-col>
      </van-row>
    </div>

    <div class="mg12">
      <van-field center readonly label="电费计算：" placeholder="" />
    </div>
    <div class="listbox">
      <van-row>
        <van-col span="6">电表编号</van-col>
        <van-col span="6">本期电量</van-col>
        <van-col span="6">基础电价</van-col>
        <van-col span="6">本期电费</van-col>
      </van-row>
      <van-row :key="index" v-for="(item,index) in meterList">
        <van-col span="6">{{item.meterNum}}</van-col>
        <van-col span="6">{{item.totalDegree}}</van-col>
        <van-col span="6">{{item.basicPrice}}</van-col>
        <van-col span="6">{{item.totalAmount}}</van-col>
      </van-row>
      <van-row>
        <van-col span="6">统计</van-col>
        <van-col span="6"></van-col>
        <van-col span="6"></van-col>
        <van-col span="6">￥{{totalAmount.toFixed(2)}}</van-col>
      </van-row>
    </div>

    <div class="mg12">
      <van-field center readonly label="缴费单据：" placeholder="" />
      <div class="upImgBox">
        <van-uploader
          v-model="imgList"
          :deletable="false"
        />
      </div>
    </div>
    
  </div>
</template>

<script>
  import axios from '@/axios.js';
  import {NavBar,Icon,Image,Toast,Button,Field,Col,Row,Uploader} from 'vant';
  export default {
    data() {
      return {
        communityName: '',
        time:'',
        payTime:'',
        totalDegree:0,
        totalAmount:0,
        meterList:[],
        imgList:[],
        imgDomain: location.protocol + "//soonsmart.keji.io/",
      };
    },
    components: {
      [NavBar.name]:NavBar,
      [Icon.name]:Icon,
      [Image.name]:Image,
      [Toast.name]:Toast, 
      [Button.name]:Button,
      [Field.name]:Field,
      [Col.name]:Col,
      [Row.name]:Row,
      [Uploader.name]:Uploader,
    },
    methods: {
      changePage(url){
        this.$router.push({path: url+".html"});
      },
      getMeterInfo() {
        axios.get("/meteruploaddegree/getmeteruploaddegree?id="+this.id).then((res)=>{
          if(res.data){
            this.meterList = res.data.meterUseList;
            this.communityId = res.data.communityId;
            this.communityName = res.data.communityName;
            this.time = res.data.endTime;
            this.payTime = res.data.uploadCertificateTime;
            res.data.paymentCertificateList.forEach(item=>{
              this.imgList.push({
                url: this.imgDomain + item
              })
            })
            this.meterList.forEach(item=>{
              this.totalDegree += item.totalDegree;
              this.totalAmount += item.totalAmount;
            })
          }
        })
      },
      onClickLeft() {
        this.$router.go(-1);
      },
      onClickRight() {
        // this.$router.push({path: "search.html",query:{pageType: 3}});
      },
    },
    computed:{
    },
    created () {
      this.id = this.$route.query.id;
      this.getMeterInfo();
    },
    mounted () {},
    destroyed () {}
  }
</script>
<style lang="less" scoped>
  body,html{width: 100%;height: 100%;background: #F0F4F7}
  .container{
    width: 100%;height: 100%;letter-spacing:0px;background: #F0F4F7;
    padding-bottom: 100px;
  }
  
  .listbox{
    width: 100%;
    color: #373737;
    background: #fff;
    margin-top: 12px;
    .van-row{
      border-bottom: 1px solid #F0F4F7;
    }
    .van-col{
      font-size: 14px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
  .mg12{margin-top: 12px;}
  .upImgBox{
    background: #fff;
    padding: 12px 18px;
    /deep/.van-uploader__upload{display: none;}
  }
</style>
